<div class="screens-header">
    <div class="screens-header-container">
        <div class="screens-actions">
            <div class="screens-back-btn" (click)="goBack()"
                role="button" tabindex="0" [attr.aria-label]="'Go back'"
                (keydown.enter)="goBack()">
                <span class="Appkit4-icon icon-left-chevron-outline"></span>
            </div>
            <div class="screens-menu-btn" (gtwClickOutside)="hideScreenList()">
                <span class="screens-menu-trigger"
                    role="button" tabindex="0" [attr.aria-label]="'Active screens menu'"
                    (click)="setActiveScreens()"
                    (keydown.enter)="setActiveScreens()">
                    <span class="Appkit4-icon icon-vertical-more-outline"></span>
                </span>
                @if (isShowing) {
<div class="screens-dropdown-panel">
                    <ap-list [bordered]="false" [split]="false"
                        [styleClass]="'screens-list'" [role]="'listbox'">
                        @for (screen of activeScreenKeys | reverseArray; track trackByMethod(i, screen); let i = $index) {
<ap-list-item
                            (click)="loadScreen(screen, i)"
                            [attr.role]="'option'"
                            [attr.aria-label]="screen.label || screen.SCREEN_NAME">
                            <span class="screen-status-dot active-dot" aria-hidden="true"></span>
                            <span class="screen-label">{{ screen.label || screen.SCREEN_NAME }}</span>
                        </ap-list-item>
}
                        @if (activeScreenKeys.length === 0) {
<ap-list-item
                            [attr.role]="'option'" [attr.aria-disabled]="'true'">
                            <span class="screen-status-dot inactive-dot" aria-hidden="true"></span>
                            <span class="screen-label">No data found</span>
                        </ap-list-item>
}
                    </ap-list>
                </div>
}
            </div>
        </div>
    </div>
</div>
